import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const Zpravy = {
	name: NAME,
	apiProvider,
	router,
};
